export const Collections = {
    USERS: 'users', // new collections with both students and companies
    V2_STUDENT_PROGRAMS: 'v2-student-programs',
    EDUCATIONS: 'educations', // not yet implemented
    COMPANIES: 'companies', // companies general information (name, size, sector...)
    RECRUITERS: 'recruiters', // not yet implemented
    COMPANY_RMS: 'company-rms', // detailed info on company Role Models
    COMPANY_TIME_FOLLOWERS: "company-time-followers",
    STUDENT_CVS: 'student-cvs', // contains student background (qualifications, jobs...), soft skills and interests
    STUDENT_SOFT_SKILLS: 'student-soft-skills', // answers to skills assessments
    COMPANY_AREAS: 'company-areas', // areas of companies
    COMPANY_MACROAREAS: 'company-macroareas', // macroareas of companies
    FEEDBACK: 'feedback', // students feedback
    GAMES: 'games',
    SUBMISSIONS: 'submissions',
    MANAGEMENT: 'management',
    ASSESSMENTS: 'assessments',
    CONTACTS: 'contacts',
    DEMO: 'demo',
    STUDENT_SOFT_SKILLS_FEEDBACK: 'student-soft-skills-feedback',
    VARIETAH: 'varietah',
    PREMIUM_REQUESTS: 'premium-requests',
    ARTICLES: 'articles',
    ARTICLE_CONTENTS: 'article-contents',
    NEWSLETTER: 'newsletter',
    COMPANY_RM_STATS: 'company-rm-stats',
    COMPANY_RM_WAITING: 'company-rm-waiting',
    COMPANY_BLACKLISTS: 'company-blacklists',
    CALLS: 'calls',
    LOGS: 'logs',
    CONTENTS: 'contents',
    CONTENT_STATS: 'content-stats',
}